<template>
  <HRApprovals
    :loading="approvalsLoading"
    :approvals="filteredApprovals"
    :approval-status="hrApprovalsStatus"
    :approval-statuses="Object.values($Constants.HR_APPROVAL_STATUSES)"
    :approval-type="hrApprovalsType"
    :approval-types="Object.values($Constants.HR_APPROVAL_TYPES)"
    :total="filteredApprovals.length"
    :filter="filter"
    :columns="columns"
    :pagination="pagination"
    :breadcrumbs="breadcrumbs"
    @select:application="selectApplication"
    @update:filter="filter = $event"
    @update:pagination="pagination = $event"
    @update:approval-status="setHrApprovalsStatus"
    @update:approval-type="setHrApprovalsType"
  />
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import columns from './columns';

export default {
  name: 'HRApprovalsWidget',
  data() {
    return {
      breadcrumbs: [{ label: 'Requests' }],
      filter: undefined,
      columns,
      pagination: {
        sortBy: 'requestedDate',
        descending: true,
        page: 0,
        rowsPerPage: 20
      }
    };
  },
  computed: {
    ...mapState({
      approvals: (state) => state.hr.approvals,
      approvalsLoading: (state) => state.hr.approvalsLoading,
      hrApprovalsStatus: (state) => state.hr.hrApprovalsStatus,
      hrApprovalsType: (state) => state.hr.hrApprovalsType
    }),
    filteredApprovals() {
      return this.approvals.filter((approval) => {
        const approvalStatus = approval.approvalStatus;
        const statusLookup =
          this.$Constants.HR_APPROVAL_STATUSES[this.hrApprovalsStatus]
            .hrApproval;
        return (
          approvalStatus === statusLookup &&
          (!this.hrApprovalsType ||
            approval.approvalType === this.hrApprovalsType)
        );
      });
    }
  },
  methods: {
    ...mapMutations('hr', ['setHrApprovalsStatus', 'setHrApprovalsType']),
    ...mapActions('hr', ['getHRApprovals']),
    selectApplication(application) {
      this.$router.push({
        name: this.$RouteNames.hrApproval,
        params: {
          id: application.approvalId || application.applicationId
        }
      });
    }
  },
  async mounted() {
    if (!this.approvalsLoading) {
      this.getHRApprovals();
    }
  },
  components: {
    HRApprovals: () => import('../../components/page/hr-approvals')
  }
};
</script>
